import React from 'react';
import { categoryToImage } from '../common';

const PrizeIcon = ({ category }) => {
  const image = categoryToImage(category);

  return (
    <div className="auction-prize-icon">
      <img src={image} alt={category} />
    </div>
  );
};

export default PrizeIcon;
